import axios, { AxiosResponse } from "axios";
import {
  PageSetting,
  SortMode,
  Query,
  GroupRaw,
  ActorTypeRaw,
} from "../../interfaces";
import ConnectionClient from "../../shared/api-client";

export const Find = async (
  collection: string,
  query: Query,
  page: number = PageSetting.page,
  limit: number = PageSetting.limit
) => {
  const { REACT_APP_API_HOST } = process.env;

  if (!REACT_APP_API_HOST) {
    throw new Error("API host is not configured.");
  }

  const metadata = `?meta=${
    query.meta ? query.meta : `total_count&page=${page}&limit=${limit}`
  }`;
  const fields = "&fields=*.*.*";
  const filter = query.filter
    ? `&${Object.entries(query.filter)
        .map(([key, value]) => `${key}=${value}`)
        .join("&")}`
    : "";
  const sort = query.sort
    ? `&sort=${query.sort
        .map(({ field, mode }) => (mode === SortMode.DES ? `-${field}` : field))
        .join(",")}`
    : "";
  const uri = `${REACT_APP_API_HOST}/items/${collection}${metadata}${fields}${filter}${sort}`;

  try {
    const response: AxiosResponse = await axios.get(uri);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data.");
  }
};

export const Create = async (actorType: ActorTypeRaw) => {
  const client = new ConnectionClient();
  const result = await client.api.post(
    `${process.env.REACT_APP_API_HOST}/items/actorTypes`,
    actorType
  );
  return result.data;
};

export const Update = async (id: string, actorType: ActorTypeRaw) => {
  const client = new ConnectionClient();
  const result = await client.api.patch(
    `${process.env.REACT_APP_API_HOST}/items/actorTypes/${id}`,
    actorType
  );
  return result.data;
};

export const Remove = async (id: string) => {
  const client = new ConnectionClient();
  const result = await client.api.delete(
    `${process.env.REACT_APP_API_HOST}/items/actorTypes/${id}`
  );
  return result.data;
};

export const FindById = async (id: string) => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${process.env.REACT_APP_API_HOST}/items/actorTypes/${id}`
  );
  return result.data;
};
